module.exports = __webpack_public_path__ + "static/media/snoopynewyear.70738901.webp";